var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row gutter-sm items-center" }, [
    _c(
      "div",
      { staticClass: "col" },
      [_c("user-avatar", { attrs: { user: _vm.user } })],
      1
    ),
    _c(
      "div",
      { staticClass: "col gt-xs" },
      [_c("q-icon", { attrs: { name: "expand_more", size: "1.275rem" } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }